import { z } from 'zod'
import { Model } from './architecture'

export const AddressRegionValidation = z.object({
  value: z.string({ required_error: '[AddressRegion] value is required' }),
})

export class AddressRegion extends Model {
  static create({ value }: z.infer<typeof AddressRegionValidation>) {
    AddressRegionValidation.parse({ value })
    return new AddressRegion(value)
  }

  constructor(private readonly _value: string) {
    super()
  }

  getAddressRegion() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.getAddressRegion() }
  }
}
